import * as React from "react";
import { Button, Popover } from "@/components/ui";
import { Info } from "lucide-react";
import { PromptType } from "@/interfaces";

interface Props {
  type: PromptType;
}

export function MediaHelpPopover({ type }: Props) {
  return (
    <Popover>
      <Popover.Trigger
        render={
          <Button variant="ghost" size="icon" className="size-6 text-slate-400 hover:text-slate-600">
            <Info className="size-4" />
          </Button>
        }
      />
      <Popover.Content className="w-80 p-0 overflow-hidden">
        <div className="bg-slate-50 border-b border-slate-200 p-3">
          <div className="font-semibold text-sm">Media Requirements</div>
          <div className="text-xs text-muted-foreground">
            Specifications for {type === PromptType.REELS ? "Reels" : "Feed"} posts
          </div>
        </div>
        <div className="p-3">
          {type === PromptType.FEED ? (
            <div className="grid gap-2 text-sm">
              <div className="flex justify-between border-b border-slate-100 pb-1">
                <span className="text-muted-foreground">File Type</span>
                <span className="font-medium">JPEG, PNG, MP4</span>
              </div>
              <div className="flex justify-between border-b border-slate-100 pb-1">
                <span className="text-muted-foreground">Aspect Ratio</span>
                <span className="font-medium">1:1, 4:5, 16:9, 9:16</span>
              </div>
              <div className="flex justify-between border-b border-slate-100 pb-1">
                <span className="text-muted-foreground">Duration</span>
                <span className="font-medium">3-90 seconds</span>
              </div>
              <div className="flex justify-between">
                <span className="text-muted-foreground">Max Size</span>
                <span className="font-medium">100MB</span>
              </div>
            </div>
          ) : (
            <div className="grid gap-2 text-sm">
              <div className="flex justify-between border-b border-slate-100 pb-1">
                <span className="text-muted-foreground">File Type</span>
                <span className="font-medium">MP4 only</span>
              </div>
              <div className="flex justify-between border-b border-slate-100 pb-1">
                <span className="text-muted-foreground">Aspect Ratio</span>
                <span className="font-medium">9:16 or 4:5</span>
              </div>
              <div className="flex justify-between border-b border-slate-100 pb-1">
                <span className="text-muted-foreground">Min Resolution</span>
                <span className="font-medium">540x960</span>
              </div>
              <div className="flex justify-between border-b border-slate-100 pb-1">
                <span className="text-muted-foreground">Ideal Resolution</span>
                <span className="font-medium">1080x1920</span>
              </div>
              <div className="flex justify-between border-b border-slate-100 pb-1">
                <span className="text-muted-foreground">Frame Rate</span>
                <span className="font-medium">24–60 FPS</span>
              </div>
              <div className="flex justify-between border-b border-slate-100 pb-1">
                <span className="text-muted-foreground">Bitrate</span>
                <span className="font-medium">Under 25 MBPS</span>
              </div>
              <div className="flex justify-between">
                <span className="text-muted-foreground">Max Size</span>
                <span className="font-medium">100 MB</span>
              </div>
            </div>
          )}
        </div>
      </Popover.Content>
    </Popover>
  );
}
